// Phase 14A — English dictionary. Stable keys, same workflow as Italian (point 22).
export default {
  "app.name": "ESG-PMI",
  "app.tagline": "VSME Standard",

  "nav.group.panoramica": "OVERVIEW",
  "nav.group.myEsg": "MY ESG",
  "nav.group.pianificazione": "PLANNING",
  "nav.group.reporting": "REPORTING & AUDIT",
  "nav.group.gestione": "COMPANY MANAGEMENT",
  "nav.group.admin": "ADMINISTRATION",
  "nav.group.consulente": "CONSULTANT",
  "nav.group.aziendaSelezionata": "SELECTED COMPANY",

  "nav.nav-dashboard": "Dashboard",
  "nav.nav-portafoglio": "Client portfolio",
  "nav.nav-note-interne": "Internal notes",
  "nav.nav-esg": "Environmental · Social · Governance",
  "nav.nav-questionario": "ESG Questionnaire",
  "nav.nav-questionario-mef": "MEF – Banks Questionnaire",
  "nav.nav-environmental": "Environmental Engine",
  "nav.nav-social": "Social Engine",
  "nav.nav-governance": "Governance Engine",
  "nav.nav-eva": "Eva — ESG Assistant",
  "nav.nav-vsme": "VSME",
  "nav.nav-documenti": "Documents",
  "nav.nav-jobtimehr": "JOBTIMEHR",
  "nav.nav-piano": "Improvement Plan",
  "nav.nav-obiettivi": "Objectives",
  "nav.nav-simulazioni": "Simulations",
  "nav.nav-questionari": "External questionnaires",
  "nav.nav-dataroom": "Data Room",
  "nav.nav-valutazione": "ESG Assessment",
  "nav.nav-report": "Reports",
  "nav.nav-pmi-banche": "PMI-Banks Dossier",
  "nav.nav-data-room": "Data Room",
  "nav.nav-audit-log": "Audit log",
  "nav.nav-azienda": "Company Profile",
  "nav.nav-utenti": "Users & Roles",
  "nav.nav-periodi": "Reporting periods",
  "nav.nav-impostazioni": "Settings",
  "nav.nav-percorso": "Guided path",
  "nav.nav-onboarding": "Onboarding & Autofill",
  "nav.nav-attivita": "Review tasks",
  "nav.nav-dashboard-consulente": "Consultant dashboard",

  "admin.standard": "Standard Management",
  "admin.factors": "Emission Factors",
  "admin.questions": "Question Library",
  "admin.frameworks": "Frameworks",
  "admin.mefIndicators": "SME–Banks indicators",
  "admin.metodologie": "Score Methodologies",
  "admin.demoRequests": "Demo Requests",
  "admin.eva": "EVA Admin",
  "admin.languages": "Languages & translations",
  "admin.regulatory": "Regulatory Update Center",
  "admin.system": "System status",

  "header.newCompany": "New company",
  "header.selectCompany": "Select company",
  "header.selectPeriod": "Period",
  "header.fiscalYear": "FY",
  "header.jtNotConnected": "JOBTIMEHR: NOT CONNECTED",
  "header.role": "Role",
  "header.settings": "Settings",
  "header.logout": "Log out",
  "header.openMenu": "Open menu",

  "company.empty.title": "No company associated",
  "company.empty.text": "Create your first company to start using the ESG platform.",
  "company.empty.cta": "Create company",

  "dialog.newCompany.title": "New company",
  "dialog.newCompany.name": "Company name *",
  "dialog.newCompany.piva": "VAT number",
  "dialog.newCompany.creating": "Creating…",
  "dialog.newCompany.submit": "Create company",
  "dialog.newCompany.created": "Company created",

  "language.label": "Language",
  "language.choose": "Choose your language",
  "language.chooseDesc": "You can change it anytime from the header or settings. Changing language does not modify data, values or periods.",
  "language.continue": "Continue in English",
  "language.current": "Current language",

  "help.askEvaPage": "Ask Eva how to use this page",
  "help.askEvaPageQuestion": "What should I do on this page?",
  "help.reserved_consultant": "This function is reserved for the consultant managing the company's ESG process.",
  "help.fallbackNotice": "This guide is not yet available in the selected language: the reference Italian version is shown.",

  "button.save": "Save",
  "button.cancel": "Cancel",
  "button.create": "Create",
  "button.delete": "Delete",
  "button.edit": "Edit",
  "button.confirm": "Confirm",
  "button.close": "Close",
  "button.send": "Send",
  "button.download": "Download",
  "button.upload": "Upload",
  "button.back": "Back",

  "common.loading": "Loading…",
  "common.error": "Error",
  "common.noData": "NO DATA AVAILABLE YET",
  "common.demo": "DEMO",

  "login.heroTitle": "The ESG operating system for SMEs.",
  "login.heroText": "Answer as an entrepreneur. The software thinks like an ESG expert. Collect, organise and report sustainability data according to the VSME standard.",
  "login.title": "Log in",
  "login.subtitle": "Enter your credentials to continue.",
  "login.signingIn": "Signing in…",
  "login.noAccount": "Don't have an account?",
  "login.register": "Sign up",

  "settings.title": "Settings",
  "settings.subtitle": "User profile, language and associated companies.",
  "settings.profile": "User profile",
  "settings.name": "Name",
  "settings.platformLevel": "Platform level",
  "settings.companyUser": "Company user",
  "settings.platformLevels.SUPER_ADMIN": "Super Admin",
  "settings.platformLevels.ORG_ADMIN": "Studio Admin",
  "settings.platformLevels.CONSULENTE": "Consultant",
  "settings.platformLevels.UTENTE_AZIENDA": "Company user",
  "header.switchToCompany": "Switch to Company context",
  "header.switchToConsultant": "Switch to Consultant context",
  "header.contextSwitched": "Context updated",
  "settings.accountCreated": "Account created on",
  "settings.memberships": "Associated companies",
  "settings.security": "Security",
  "settings.securityText": "The platform uses JWT authentication with encrypted passwords (bcrypt), secure sessions, server-side access control and complete data isolation between companies. Password change and two-factor authentication will be available in upcoming phases.",
  "settings.language.title": "Language",
  "settings.language.text": "Language is a personal preference: interface, Eva and the guide update immediately, without logging out. It does not modify data, values or periods.",
  "settings.language.saved": "Language updated",
  "settings.manual.title": "Operational manual",
  "settings.manual.text": "The ESG-PMI operational guide in PDF, generated from the same Knowledge Base as Eva.",
  "settings.manual.clientIt": "Guida Azienda — Italiano",
  "settings.manual.clientEn": "Company User Guide — English",
  "settings.manual.consultantIt": "Manuale Consulente — Italiano",
  "settings.manual.consultantEn": "Consultant Manual — English",

  "periodStatus.DRAFT": "Draft",
  "periodStatus.IN_PROGRESS": "In progress",
  "periodStatus.IN_REVIEW": "Under review",
  "periodStatus.APPROVED": "Approved",
  "periodStatus.LOCKED": "Locked",

  "roleLabels.SUPER_ADMIN": "Super Admin",
  "roleLabels.CONSULENTE": "Consultant",
  "roleLabels.ADMIN_AZIENDA": "Company Admin",
  "roleLabels.ESG_MANAGER": "ESG Manager",
  "roleLabels.HR_MANAGER": "HR Manager",
  "roleLabels.DATA_ENTRY": "Data Entry",
  "roleLabels.VIEWER": "Viewer",
  "roleLabels.REVISORE": "Reviewer",

  "eva.title": "Eva — ESG Assistant",
  "eva.subtitle": "ESG-PMI's intelligent assistant. It answers using only authorised platform data.",
  "eva.newConversation": "New conversation",
  "eva.noConversations": "No previous conversations.",
  "eva.welcomeTitle": "Hi, I'm Eva.",
  "eva.welcomeText": "I can help you understand your company's ESG data, check what is missing for VSME and SME-Banks, guide you through the platform and explain the KPIs already available.",
  "eva.welcomeConsultant": "As a consultant you can also ask me to prepare reports, Data Rooms, scenarios and improvement actions: I will always ask for your confirmation before performing any action.",
  "eva.placeholder": "Ask Eva something about your ESG data or how to use the platform…",
  "eva.footerNote": "Eva only uses authorised platform data, states when information is unavailable and never performs write actions without your explicit confirmation.",
  "eva.modeConsultant": "Consultant mode",
  "eva.modeClient": "Client mode",
  "eva.contextTitle": "Working context",
  "eva.contextCompany": "Company",
  "eva.contextPeriod": "Period",
  "eva.contextMode": "Mode",
  "eva.sourcesTitle": "Sources used in this conversation",
  "eva.sourcesEmpty": "The sources used by Eva will appear here, with links to the platform section the data comes from.",
  "eva.pendingConfirmations": "{count} action(s) awaiting your confirmation",
  "eva.consulting": "Eva is consulting",
  "eva.confirmation.proposes": "Eva proposes",
  "eva.confirmation.highImpact": "HIGH-IMPACT ACTION",
  "eva.confirmation.write": "WRITE ACTION",
  "eva.confirmation.hint": "The action is executed only with your confirmation.",
  "eva.confirmation.executed": "✓ Action executed after your confirmation.",
  "eva.confirmation.cancelled": "Action cancelled.",
  "eva.confirmation.expired": "Confirmation expired: ask Eva again.",
  "eva.confirmation.failed": "Execution failed.",
  "eva.deleteConversation": "Delete conversation",
  "eva.stopAnswer": "Stop answer",
  "eva.sendMessage": "Send message",
  "eva.regenerate": "Regenerate answer",
  "eva.loading": "Loading Eva…",
  "eva.accessDeniedTitle": "Eva is not available for this account",
  "eva.accessDeniedText": "Eva works on company ESG data. The platform Super Admin account does not have access to company data: to use Eva, sign in with a company or consulting firm account.",

  "adminLang.title": "Languages & translations",
  "adminLang.subtitle": "Language & Translation Management: language status, content coverage, translation review and feedback.",
  "adminLang.coverage": "Coverage",
  "adminLang.status": "Status",
  "adminLang.reviewQueue": "Translation review queue",
  "adminLang.feedback": "Translation feedback",
  "adminLang.analytics": "Usage (aggregated)",
  "adminLang.markVerified": "Verify",
  "adminLang.markActive": "Activate",
  "adminLang.deprecate": "Deprecate",
  "adminLang.noTranslations": "No translations in review.",
  "adminLang.statusUpdated": "Status updated",

  "dash.title": "ESG Dashboard",
  "dash.welcome": "Welcome, {name}. Sustainability overview of",
  "dash.activePeriod": "Active period:",
  "dash.fiscalYear": "FY {year}",
  "dash.widget.score": "ESG PMI Score",
  "dash.widget.journey": "Valid ESG answers",
  "dash.widget.vsme": "VSME datapoints available",
  "dash.widget.mef": "MEF – Banks Questionnaire",
  "dash.widget.companyData": "Company data",
  "dash.widget.dataStatus": "Verified / missing data",
  "dash.widget.locker": "ESG Document Locker",
  "dash.widget.openActions": "Open actions",
  "dash.widget.submission": "Submission to the consultant",
  "dash.widget.sharedReports": "Reports shared by the consultant",
  "dash.widget.extq": "External questionnaires",
  "dash.widget.extqTodo": "Questionnaires to complete",
  "dash.pillar.e": "Environmental",
  "dash.pillar.s": "Social",
  "dash.pillar.g": "Governance",
  "dash.missing": "Missing information",
  "dash.toVerify": "To verify",
  "dash.docsUploaded": "Documents uploaded",
  "dash.govSections": "Governance areas fully completed",
  "dash.govSectionsVerified": "of which fully verified",
  "dash.tipGovSections": "Governance areas with all data entered; final verification is up to the consultant.",
  "dash.continue": "Continue filling in",
  "dash.openVsme": "Open VSME engine",
  "dash.openMef": "Open bank dossier",
  "dash.openValutazione": "Open the ESG Assessment (methodological score + Data Quality)",
  "dash.openEngine": "Open the engine",
  "dash.openLocker": "Open the ESG Document Locker",
  "dash.openPlan": "Open the plan",
  "dash.gotoQuestionnaire": "Go to the questionnaire",
  "dash.openExtq": "Open the questionnaires",
  "dash.scoreSourceNote": "Methodological ESG PMI Score (ScoreRun): the single source of truth, computed on the period's canonical data. Distinct from VSME completeness.",
  "dash.scoreEmpty": "No assessment has been calculated for this fiscal year.",
  "dash.scoreError": "Unable to load the score. Please try again shortly.",
  "dash.scoreStale": "Data changed after this calculation: the score needs recalculation.",
  "dash.scoreStatus.CURRENT": "Up to date",
  "dash.scoreStatus.STALE": "Recalculate",
  "dash.scoreStatus.INSUFFICIENT_DATA": "Insufficient data",
  "dash.scoreStatus.CALCULATING": "Calculating…",
  "dash.scoreStatus.FAILED": "Calculation failed",
  "dash.scoreInsufficient": "Period data coverage at {coverage}%: insufficient for a reliable assessment.",
  "dash.pillarEmpty": "No data available for this pillar in the period.",
  "dash.pillarStats": "{completed} available · {missing} missing · VSME datapoints available",
  "dash.notActive": "Not active",
  "dash.missingData": "Missing data",
  "dash.approved": "Approved",
  "dash.p1": "Priority (P1)",
  "dash.coveredVsme": "Covered by VSME",
  "dash.toIntegrate": "To integrate",
  "dash.sector": "Sector",
  "dash.employees": "Employees",
  "dash.managedUsers": "Managed users",
  "dash.esgPeriods": "ESG periods",
  "dash.verified": "Verified",
  "dash.docsInPeriod": "documents uploaded in the period",
  "dash.docCoverage": "Documentation",
  "dash.docsRequestedOne": "document requested by the consultant",
  "dash.docsRequestedMany": "documents requested by the consultant",
  "dash.openActionsInPlan": "open actions in the improvement plan",
  "dash.submissionState": "Compilation status:",
  "dash.openRequests": "Consultant requests to fulfil:",
  "dash.sharedReportsCount": "approved reports shared with your company",
  "dash.downloadPdf": "Download PDF",
  "dash.extqAwaiting": "awaiting review",
  "dash.extqOne": "questionnaire to complete",
  "dash.extqMany": "questionnaires to complete",
  "dash.extqToComplete": "to complete",
  "dash.extqToVerify": "to verify",
  "dash.askEva": "Ask Eva",
  "dash.askEvaSub": "What do you want to know about your ESG?",
  "dash.askEvaPlaceholder": "E.g. What is missing from my VSME?",
  "dash.askEvaSubmit": "Ask",
  "dash.qCard.title": "ESG Questionnaire",
  "dash.qCard.completed": "Completed",
  "dash.qCard.inProgress": "In progress",
  "dash.qCard.notStarted": "Not started",
  "dash.qCard.status": "Status:",
  "dash.qCard.questions": "({answered} of {visible} questions)",
  "dash.qCard.empty": "Answer a few simple questions: the software translates them into VSME data.",
  "dash.qCard.continue": "CONTINUE QUESTIONNAIRE",
  "dash.qCard.start": "START YOUR ESG JOURNEY",
  "dash.qCard.fullNote": "100% means every question has an answer. Answers still need to be verified by the consultant.",
  "dash.compileMef": "Fill in the MEF – Banks Questionnaire",
  "dash.mefQuestions": "Questions answered",
  "dash.mefCoverage": "Information already available from ESG data",
  "dash.mefToVerify": "To verify",
  "dash.openMefSummary": "Open MEF summary",
  "dash.tipQuestionsPct": "Share of questions with an answer, over the visible questionnaire questions.",
  "dash.tipVsmePct": "Share of VSME information available over applicable datapoints (source: VSME engine).",
  "dash.tipMefPct": "Share of the 40 MEF Document items already covered by entered data (VSME or direct answers).",
  "questionnaireState.DA_INIZIARE": "Not started",
  "questionnaireState.IN_COMPILAZIONE": "In progress",
  "questionnaireState.COMPLETO_DA_INVIARE": "Complete — to send to the consultant",
  "questionnaireState.INVIATO_AL_CONSULENTE": "Sent to the consultant",
  "questionnaireState.IN_REVISIONE": "Under consultant review",
  "questionnaireState.RICHIESTA_INTEGRAZIONE": "Integration requested by the consultant",
  "questionnaireState.ACCETTATO_PER_ANALISI": "Accepted for analysis",
  "questionnaireState.APPROVATO": "Approved",
  "questionnaireState.RIAPERTO": "Reopened for changes",
  "dash.nextSteps.title": "Recommended next steps",
  "dash.nextSteps.text": "Complete the company profile, invite your team and prepare the ESG reporting periods.",
  "dash.nextSteps.company": "Company profile",
  "dash.nextSteps.periods": "ESG periods",

  "submissionStatus.DRAFT": "Draft — not submitted",
  "submissionStatus.SUBMITTED_BY_COMPANY": "Submitted to the consultant",
  "submissionStatus.UNDER_CONSULTANT_REVIEW": "Under consultant review",
  "submissionStatus.RETURNED_FOR_CORRECTION": "Returned for integration",
  "submissionStatus.ACCEPTED_FOR_ANALYSIS": "Accepted for analysis",
  "submissionStatus.APPROVED_BY_CONSULTANT": "Approved by consultant",
  "submissionStatus.SENT_TO_BANK": "Sent to the bank",
  "questionnaireState.APPROVATO_DAL_CONSULENTE": "Approved by consultant",
  "questionnaireState.INVIATO_ALLA_BANCA": "Sent to the bank",
  "submissionStatus.INTEGRATION_REQUIRED": "To be integrated",
  "submissionStatus.READY_FOR_RESUBMISSION": "Ready to resubmit",
  "questionnaireState.DA_INTEGRARE": "To be integrated",
  "questionnaireState.PRONTO_PER_NUOVO_INVIO": "Ready to resubmit",
  "dash.validAnswersPct": "Valid ESG answers",
  "dash.vsmeDatapointsPct": "VSME datapoints available",
  "dash.mefValidPct": "Valid MEF questions",
  "dash.govDatapointsPct": "Governance VSME datapoints available",
  "settings.subscription.title": "Subscription",
  "settings.subscription.current": "Current plan",
  "settings.subscription.none": "No active subscription",
  "settings.subscription.choose": "Choose plan",
  "settings.subscription.monthly": "monthly",
  "settings.subscription.yearly": "yearly",
  "settings.subscription.checkout_error": "Unable to start checkout",
  "settings.subscription.status": "Status",
  "settings.subscription.manage_hint": "Upgrades are immediate; automatic downgrades are not supported.",
};
